/**
 * ==========================================================
 * GBM Store - Quote Engine
 * Version: 2.0.0
 * ==========================================================
 */

class QuoteDocument {

    constructor() {

        this.cart = null;

        this.context = {
            country: null,
            company: null,
            customerId: null
        };

        this.dom = {
            tbody: document.getElementById("quote-products-body"),
            subtotal: document.getElementById("quote-subtotal"),
            tax: document.getElementById("quote-tax"),
            total: document.getElementById("quote-total"),

            currency: document.getElementById("quote-currency"),
            delivery: document.getElementById("quote-delivery"),
            date: document.getElementById("quote-date"),

            printButton: document.getElementById("printQuote")
        };

    }

    async init() {

        console.log("🚀 GBM Quote Engine iniciado");

        this.loadContext();

        this.renderCurrentDate();

        this.registerEvents();

        await this.loadCart();

    }

    loadContext() {

        const element = document.getElementById("quote-data");

        if (!element) {

            console.warn("Quote context no encontrado.");

            return;

        }

        this.context.country =
            (element.dataset.country || "")
                .trim()
                .toUpperCase();

        this.context.company =
            element.dataset.company || "";

        this.context.customerId =
            element.dataset.customerId || "";

    }

    renderCurrentDate() {

        if (!this.dom.date) return;

        const today = new Date();

        this.dom.date.textContent = today.toLocaleDateString("es-HN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });

    }

    registerEvents() {

        if (!this.dom.printButton) return;

        this.dom.printButton.addEventListener("click", () => {

            window.print();

        });

    }
    async loadCart() {

        try {

            const response = await fetch("/cart.js");

            if (!response.ok) {
                throw new Error("No fue posible obtener el carrito.");
            }

            this.cart = await response.json();

            console.log("🛒 Carrito cargado:", this.cart);

            this.renderProducts();

            this.renderSummary();

            this.renderCommercialInfo();

        }
        catch (error) {

            console.error("QuoteDocument:", error);

        }

    }

    getItems() {

        return this.cart?.items || [];

    }

    money(value) {

        return new Intl.NumberFormat("en-US", {

            style: "currency",
            currency: this.cart.currency

        }).format(value / 100);

    }

    getCustomerCountry() {

        return this.context.country;

    }

    getTaxRate(country) {

        const taxRates = {

            HN: 0.15,
            SV: 0.13,
            GT: 0.12,
            CR: 0.13,
            PA: 0.07,
            DO: 0.18

        };

        return taxRates[country] ?? 0;

    }

        createProductRow(item) {

        return `
            <tr>

                <td style="text-align:center;">

                    <img
                        src="${item.image}"
                        alt="${item.product_title}"
                        style="
                            width:65px;
                            border-radius:8px;
                        ">

                </td>

                <td>

                    <a
                        href="${item.url}"
                        target="_blank"
                        style="
                            color:#222;
                            text-decoration:none;
                            font-weight:600;
                        ">

                        ${item.product_title}

                    </a>

                    <br>

                    <small style="color:#666;">

                        SKU: ${item.sku}

                    </small>

                    <br>

                    <small style="color:#666;">

                        Fabricante: ${item.vendor}

                    </small>

                </td>

                <td style="text-align:center;">

                    ${item.quantity}

                </td>

                <td style="text-align:right;">

                    ${this.money(item.final_price)}

                </td>

                <td style="text-align:right;">

                    ${this.money(item.final_line_price)}

                </td>

            </tr>
        `;

    }

    renderProducts() {

        if (!this.dom.tbody) return;

        this.dom.tbody.innerHTML = "";

        this.getItems().forEach(item => {

            this.dom.tbody.insertAdjacentHTML(

                "beforeend",

                this.createProductRow(item)

            );

        });

    }

    calculateTotals() {

        const subtotal = this.cart.items_subtotal_price;

        const country = this.getCustomerCountry();

        const taxRate = this.getTaxRate(country);

        const tax = Math.round(subtotal * taxRate);

        const total = subtotal + tax;

        return {

            subtotal,
            tax,
            total,
            taxRate,
            country

        };

    }

    renderSummary() {

        if (!this.cart) return;

        const totals = this.calculateTotals();

        if (this.dom.subtotal) {

            this.dom.subtotal.textContent =
                this.money(totals.subtotal);

        }

        if (this.dom.tax) {

            this.dom.tax.textContent =
                this.money(totals.tax);

        }

        if (this.dom.total) {

            this.dom.total.textContent =
                this.money(totals.total);

        }

    }

    renderCommercialInfo() {

        if (!this.cart) return;

        if (this.dom.currency) {

            this.dom.currency.textContent =
                this.cart.currency;

        }

        if (this.dom.delivery) {

            this.dom.delivery.textContent =
                this.cart.note || "Por confirmar";

        }

    }

}

document.addEventListener("DOMContentLoaded", async () => {

    const quote = new QuoteDocument();

    await quote.init();

});